module.exports = __webpack_public_path__ + "static/media/white_city.0ff82dfa.jpg";